/* Units */
export const units = {
  "Naturalness": "%",
  "AverageMolecularWeight": "g/mol",
  "Average Molecular Weight": "g/mol",
  "EquivalentAlkaneCarbonNumber": "",
  "Equivalent Alkane Carbon Number": "",
  "InterfacialTension": "mN/m",
  "Interfacial Tension": "mN/m",
  "Spreadability": "mm2/10min",
  "SurfaceTension": "mN/m",
  "Surface Tension": "mN/m",
  "Viscosity": "mPa·s",
}

/* Handle Scrolling */
export const scrollTo = (y = 0, x = 0) => {
  window.scrollTo(0,0);
}

export const addScrollListener = (className) => {
  const target = className ? document.getElementsByClassName(className)[0] : document;
  target.addEventListener('scroll', onScroll);
}

export const removeScrollListener = (className) => {
  const target = className ? document.getElementsByClassName(className)[0] : document;
  target.removeEventListener('scroll', onScroll);
}

export const getScrollTop = (className) => {
  const target = className ? document.getElementsByClassName(className)[0] : document.documentElement;
  const scrollTop = target.scrollTop || window.pageYOffset;
  return scrollTop;
}
// var to = null;
// var blocked = false;
var lastScrollTop = 0;

export const onScroll = (event) => {
  const target = event.currentTarget || document.documentElement;
  const scrollTop = target.scrollTop || window.pageYOffset;
  const classes = document.body.classList;
  //console.log(lastScrollTop,scrollTop);
  if(scrollTop >= lastScrollTop){
    classes.add("scrolledUp");
    classes.remove("scrolledDown");
  } else {
    classes.add("scrolledDown");
    classes.remove("scrolledUp")
  }
  if(scrollTop > 80){
    classes.add("scrolled");
  } else {
    classes.remove("scrolled");
    classes.remove("scrolledUp");
    classes.remove("scrolledDown");
  }
  // if(!blocked){
  //   onDelayedScroll(event);
  //   blocked = true;
  //   if(to){
  //     clearTimeout("to");
  //     to = null;
  //   }
  //   to = setTimeout(() => {
  //     onDelayedScroll(event);
  //     blocked = false;
  //   }, 300)
  // }
  lastScrollTop = scrollTop;
}

// const onDelayedScroll = (event) => {
//   const target = event.currentTarget || document.documentElement;
//   const scrollTop = target.scrollTop || window.pageYOffset;
//   const classes = document.body.classList;
//   if(scrollTop >= lastScrollTop){
//     classes.add("scrolledUp");
//     classes.remove("scrolledDown");
//   } else {
//     classes.add("scrolledDown");
//     classes.remove("scrolledUp")
//   }
// }

export const toggleScroll = (scroll) => {
  const root = document.getElementsByTagName("html")[0];
  if(scroll){
    //document.body.classList.remove("noscroll");
    root.classList.remove("noscroll");
  } else {
    //document.body.classList.add("noscroll");
    root.classList.add("noscroll");
  }
}

/* Tooltip */
var ttto;
export const moveTooltip = (e) => {
  const tt = document.getElementById("tooltip");
  //if(!tt || !tt.textContent){return;}
  const w = tt ? tt.offsetWidth + 5 : 0;
  const h = tt ? tt.offsetHeight + 5 : 0;
  const scrollTop = getScrollTop();
  const margin = 20;
  const maxX = window.innerWidth - w - margin;
  const minY = scrollTop + margin + 60;
  const maxY = window.innerHeight + scrollTop - h - margin;
  const currX = e.pageX - w;
  const currY = e.pageY - h - scrollTop;
  const x = parseInt((currX + w) > maxX ? maxX : currX < 0 ? margin : currX);
  const y = parseInt(scrollTop + currY < minY ? currY + h : currY);
  const pos = `left:${x}px; top:${y}px;`;
  tt.setAttribute("style", pos);
  if(ttto){
    clearTimeout(ttto);
  }
  setTimeout(function(){
    window.removeEventListener("mousemove", moveTooltip);
  }, 600);
}

export const toggleTooltip = (e, data) => {
  const tt = document.getElementById("tooltip");
  const div = tt.getElementsByTagName("div")[0];
  const span = div.getElementsByTagName("span")[0];
  const p = div.getElementsByTagName("p")[0];
  const {key, label, title, text} = data || {};
  const eText = !!e && !data && !text ? e.currentTarget.textContent : null;
  const hl = title || label || key || eText;
  const txt = getTooltipText(hl) || text;
  if(!!e && e.type !== "mouseout" && e.type !== "mouseleave" && !!tt && !!hl && !!txt){
    e.stopPropagation();
    span.textContent = hl;
    p.textContent = txt;
    tt.classList.add("active");
    window.addEventListener("mousemove", moveTooltip);
  } else if(!!tt) {
    tt.classList.remove("active");
    window.removeEventListener("mousemove", moveTooltip);
    // span.textContent = "";
    // p.textContent = "";
  }
}

export const getTooltipText = (label) => {
  const str = label ? label.toLowerCase().replace(/ /g, '').replace(/-/g, '') : "";
  switch (str){
    case "naturalness":
      return "% of C atoms constituted by natural raw ingredients."
    case "equivalentalkanecarbonnumber":
      return "Comparison with alkanes using PIT emulsion process";
    case "interfacialtension":
      return "Energy required for an unit emollient-water area. Higher IFT signifies low POLARITY and vice-versa.";
    case "refractiveindex":
      return "Ratio of speed of light in vacuum to the emollient.";
    case "spreadability":
      return "The area of skin covered by a drop of an emollient after 10 mins.";
    case "surfacetension":
      return "Energy required for an unit emollient-air area.";
    case "viscosity":
      return "Flow behavior at a shear rate of 100 s-1";
    case "rocushiony":
    case "rodistribution":
    case "rooil":
    case "rowetness":
    case "rothickness":
      return "RO sensory attributes characterize rub-out phase after application.";
    case "tigliding":
    case "tismoothness":
    case "tistickyness":
    case "tistickiness":
    case "tipowdery":
    case "tiresidue1":
    case "tiresidue2":
    case "tisiliconeoilfeel":
    case "tiwaxdry":
      return "TI sensory attributes characterize immediate after-feel";
    case "averagemolecularweight":
    case "smoothness":
    case "stickiness":
    case "thickness":
    case "gliding":
    case "wetness":
    default:
      return null
  }
}

/* Converter */
export const hexToRGBA = (hex, a) => {
  hex = '0x' + hex.replace(/#/g, '')
  let r = hex >> 16 & 0xFF
  let g = hex >> 8 & 0xFF
  let b = hex & 0xFF
  return `rgba(${r}, ${g}, ${b}, ${a || 1})`
}

/* Shuffle Array*/
export const shuffle = (arr) => {
  let ctr = arr.length;
  let temp;
  let index;
  // While there are elements in the array
  while (ctr > 0) {
    // Pick a random index
    index = Math.floor(Math.random() * ctr);
    // Decrease ctr by 1
    ctr--;
    // And swap the last element with it
    temp = arr[ctr];
    arr[ctr] = arr[index];
    arr[index] = temp;
  }
  return arr;
}

/* Convert key to label */
export const toLabel = (str) => {
  return str
    .replace(/INCI_Name/g, 'INCI Name (EU)') // preferencially this has to be changed in data
    .replace(/Gliding/g, 'TiGliding') // preferencially this has to be changed in data
    .replace(/Smoothness/g, 'TiSmoothness') // preferencially this has to be changed in data
    .replace(/Stickiness/g, 'TiStickiness') // preferencially this has to be changed in data
    .replace(/Thickness/g, 'RoThickness') // preferencially this has to be changed in data
    .replace(/Wetness”/g, 'RoWetness”') // preferencially this has to be changed in data
    .replace(/_/g, ' ')
    .replace(/Ro/g, 'Ro-') // preferencially this has to be changed in data
    .replace(/Ti/g, 'Ti-') // preferencially this has to be changed in data
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
}

/* Shorten Labels */
export const shortLabels = {
  "AverageMolecularWeight": "MW",
  "EquivalentAlkaneCarbonNumber": "EACN",
  "InterfacialTension": "IFT",
  "RefractiveIndex": "RI",
  "Spreadability": "SP",
  "SurfaceTension": "SFT",
  "Viscosity": "Vis"
}

/* Convert string to number */
export const decs = {
  "EquivalentAlkaneCarbonNumber": 1,
  "InterfacialTension": 1,
  "RefractiveIndex": 3,
  "SurfaceTension": 1,
  "Viscosity": 1
}

/* Add missing zeros */
export const addDecimals = (item) => {
  const dec = decs[item.key] || 0;
  // const intStr = item.value.toString().split(".")[0];
  // const decStr = item.value.toString().split(".")[1] || "";
  // const newDecs = dec && decStr.length < (dec+1) ? (`.${decStr}000000`).substr(0, dec+1) : "";
  return dec ? item.value.toFixed(dec) : item.value;//`${intStr}${newDecs}`;
}

export const toNum = (str, key) => {

  const strValue = str ? str.replace(/,/g, '.') : "";
  if(!str || isNaN(strValue)){
//if(key==="RefractiveIndex")console.log(strValue, str);
    return -1;
  } else if(!!key){
    const keyStr = key.replace(/ /g, '');
    // const int = str.replace(/,/g, '.').split(".")[0];
    // const dec = decs[keyStr] ? strValue.split(".")[1] : false;
    // const num = parseFloat(`${int}${!!dec ? "."+dec.substr(0, decs[keyStr]) : ""}`);
    const value = parseFloat(strValue).toFixed(decs[keyStr] ? decs[keyStr] : 0);
    //const value = decs[keyStr] ? parseFloat(strValue).toFixed(decs[keyStr]) : parseFloat(strValue) ;
    const num = parseFloat(value);
    return num;
  } else {
    return parseFloat(strValue);
  }
}

/* Convert string to className */
export const str2class = (str = "") => {
  return str ? str.toLowerCase().replace(/\n|[^a-z0-9-]+/g,"-").replace(/--+/g,"-").trim().substr(0,20).trim() : "";
}

/* Convert string to form field name */
export const str2name = (str = "") => {
  return str ? str.toLowerCase().replace(/\n|[^a-z0-9-\u005B\u005D]+/g,"-").trim().substr(0,20).trim() : "";
}

/* Convert className to title */
export const toTitle = (str = "") => {
  return str ? (str.charAt(0).toUpperCase() + str.slice(1)).replace(/[^a-zA-Z0-9&,?!]+/g," ").trim() : "";
}

/* Convert string to alias */
export const toAlias = (str = "") => {
  const ignore = ["over", "from", "with", "and", "for"]
  const suffix = str.indexOf("-") > -1 ? str.split("-")[1].substr(0, 1)
    : str.split(" ").length > 2 ? str.split(" ").slice(1).filter(i => i.length > 2 && ignore.indexOf(i.toLowerCase()) === -1).map(i => i.replace(/[aeiouAEIOU]+/g,"").substr(0, 1)).join("")
    : str.split(" ").length === 2 ? str.split(" ")[1].replace(/[aeiouAEIOU]+/g,"").substr(0, 2)
    : str.substr(2).replace(/[aeiouAEIOU ]+/g,"").substr(0, 1);
  const prefix = str.indexOf(" ") > -1 && suffix.length > 1 ? str.substr(0, 1) : !suffix.length ? str.substr(0, 3) : str.substr(0, 2);
  const alias = prefix.toUpperCase()+suffix.substr(0, 2).toUpperCase();
  return alias;
}

/* Date converter */
const dateTimeDel = " at ";
const dateDel = "-";
const timeDel = ":";
const zone = new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];
export const tsToDateStr = (timestamp = 0) => {
  const date = timestamp.toString().length===10 ? new Date(timestamp*1000) : new Date(timestamp);
  const y = date.getFullYear();
  const m = date.getMonth()+1 < 10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
  const d = date.getDate() < 10 ? "0"+date.getDate() : date.getDate();
  return d+dateDel+m+dateDel+y
}

export const dateStrToTs = (date = "") => {
  const y = parseInt(date.split(dateDel)[0]);
  const mInt = parseInt(date.split(dateDel)[1])-1;
  const m = new Date(y,mInt).toLocaleString("en-us",{month:"long"});
  const d = date.split(dateDel)[2];
  const localDate = new Date(m+" "+d+", "+y);
  return localDate.getTime()/1000-localDate.getTimezoneOffset()*60*60;
}

export const tsToDateTimeStr = (timestamp = 0) => {
  const date = timestamp.toString().length===10 ? new Date(timestamp*1000) : new Date(timestamp);
  const y = date.getFullYear();
  const m = date.getMonth()+1 < 10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
  const d = date.getDate() < 10 ? "0"+date.getDate() : date.getDate();
  const h = date.getHours() < 10 ? "0"+date.getHours() : date.getHours();
  const min = date.getMinutes() < 10 ? "0"+date.getMinutes() : date.getMinutes();
  //const s = date.getSeconds() < 10 ? "0"+date.getSeconds() : date.getSeconds();
  return y+dateDel+m+dateDel+d+dateTimeDel+h+timeDel+min;//+timeDel+s;
}

export const tsToTimeStr = (timestamp = 0) => {
  const date = timestamp.toString().length===10 ? new Date(timestamp*1000) : new Date(timestamp);
  //const h = date.getHours() < 10 ? "0"+date.getHours() : date.getHours();
  const min = date.getMinutes() < 10 ? "0"+date.getMinutes() : date.getMinutes();
  const s = date.getSeconds() < 10 ? "0"+date.getSeconds() : date.getSeconds();
  return min+timeDel+s;
}

export const dateTimeStrToTs = (date = "") => {
  const y = date.split(dateTimeDel)[0].split(dateDel)[2];
  const mInt = parseInt(date.split(dateTimeDel)[0].split(dateDel)[1])-1;
  const m = new Date(y,mInt).toLocaleString("en-us",{month:"long"});
  const d = parseInt(date.split(dateTimeDel)[0].split(dateDel)[0]);
  const t = date.split(dateTimeDel)[1];
  const localDate = new Date(m+" "+d+", "+y+" "+t);
  return localDate.getTime();
}

/* Return a random Integer within a specific range */
export const randomRange = (min, max) => {
  return Math.floor(Math.random()*(max+1-min)+min);
}

export const randomNum = () => {
  const str = Math.floor((Math.random() * 99999999));
  return str;
}

/* Return a unique Id */
export const uniqueId = (length = 16) => {
  // always start with a letter (for DOM friendlyness)
  let idstr=String.fromCharCode(Math.floor((Math.random()*25)+65));
  do {
      // between numbers and characters (48 is 0 and 90 is Z (42-48 = 90)
      var ascicode=Math.floor((Math.random()*42)+48);
      if (ascicode<58 || ascicode>64){
          // exclude all chars between : (58) and @ (64)
          idstr+=String.fromCharCode(ascicode);
      }
  } while (idstr.length<length);
  const date = Date.now();
  return idstr+"-"+date.toString();
}


/* Sort array of objects */
export const byProperty = (propertyName, order = "asc") => {
  switch(order.toLowerCase()){
    case "desc":
      return (a, b) => {
        if(a[propertyName] > b[propertyName]) return -1;
        if(a[propertyName] < b[propertyName]) return 1;
        return 0;
      }
    default:
      return (a, b) => {
        if(a[propertyName] > b[propertyName]) return 1;
        if(a[propertyName] < b[propertyName]) return -1;
        return 0;
      }
  }
}

/* Toggle BodyClass "hover" between touch- and mouse-events" */
export const checkHover = () => {
    let hasHoverClass = false;
    let container = document.body;
    let lastTouchTime = 0;

    const enableHover = () => {
      // filter emulated events coming from touch events
      if (Date.now() - lastTouchTime < 500) return;
      if (hasHoverClass) return;
      container.classList.add("hover");
      hasHoverClass = true;
    }

    const disableHover = () => {
      updateLastTouchTime()
      if (!hasHoverClass) return;
      container.classList.remove("hover");
      hasHoverClass = false;
    }

    const updateLastTouchTime = () => {
      lastTouchTime = Date.now();
    }

    document.addEventListener('touchstart', disableHover, true);
    document.addEventListener('mousemove', enableHover, true);
    enableHover();
}

/* react-beautiful-dnd */
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

/* get hex color from a gradient */
export const getGradientColor = (start_color, end_color, percent) => {
   // strip the leading # if it's there
   start_color = start_color.replace(/^\s*#|\s*$/g, '');
   end_color = end_color.replace(/^\s*#|\s*$/g, '');

   // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
   if(start_color.length === 3){
     start_color = start_color.replace(/(.)/g, '$1$1');
   }

   if(end_color.length === 3){
     end_color = end_color.replace(/(.)/g, '$1$1');
   }

   // get colors
   var start_red = parseInt(start_color.substr(0, 2), 16),
       start_green = parseInt(start_color.substr(2, 2), 16),
       start_blue = parseInt(start_color.substr(4, 2), 16);

   var end_red = parseInt(end_color.substr(0, 2), 16),
       end_green = parseInt(end_color.substr(2, 2), 16),
       end_blue = parseInt(end_color.substr(4, 2), 16);

   // calculate new color
   var diff_red = end_red - start_red;
   var diff_green = end_green - start_green;
   var diff_blue = end_blue - start_blue;

   diff_red = ( (diff_red * percent) + start_red ).toString(16).split('.')[0];
   diff_green = ( (diff_green * percent) + start_green ).toString(16).split('.')[0];
   diff_blue = ( (diff_blue * percent) + start_blue ).toString(16).split('.')[0];

   // ensure 2 digits by color
   if( diff_red.length === 1 ) diff_red = '0' + diff_red
   if( diff_green.length === 1 ) diff_green = '0' + diff_green
   if( diff_blue.length === 1 ) diff_blue = '0' + diff_blue

   return '#' + diff_red + diff_green + diff_blue;
 };
